import { styled, theme } from '../stitches.config';
import { rem } from '../util';

export const Badge = styled('span', {
  backgroundColor: '$$backgroundColor',
  borderRadius: rem(4),
  color: '$$color',
  display: 'inline-block',
  fontFamily: theme.fonts.sansSerif,
  fontWeight: theme.fontWeights.medium,
  textTransform: 'uppercase',

  variants: {
    color: {
      gray: {
        $$backgroundColor: theme.colors.gray4,
        $$color: theme.colors.gray11,
      },
      blue: {
        $$backgroundColor: theme.colors.blue4,
        $$color: theme.colors.blue11,
      },
      green: {
        $$backgroundColor: theme.colors.green4,
        $$color: theme.colors.green11,
      },
      lightRed: {
        $$backgroundColor: theme.colors.red2,
        $$color: theme.colors.red10,
      },
      red: {
        $$backgroundColor: theme.colors.red9,
        $$color: theme.colors.red3,
      },
      yellow: {
        $$backgroundColor: theme.colors.yellow4,
        $$color: theme.colors.yellow11,
      },
      orange: {
        $$backgroundColor: theme.colors.yellow8,
        $$color: theme.colors.white,
      },
      lightGray: {
        $$backgroundColor: theme.colors.gray1,
        $$color: theme.colors.gray11,
        border: `1px solid ${theme.colors.gray7}`,
      },
      darkBlue: {
        $$backgroundColor: theme.colors.blue11,
        $$color: theme.colors.blue1,
      },
    },
    size: {
      tiny: {
        fontSize: rem(14),
        lineHeight: rem(20),
        paddingLeft: rem(8),
        paddingRight: rem(8),
      },
      small: {
        fontSize: rem(16),
        lineHeight: rem(24),
        paddingLeft: rem(8),
        paddingRight: rem(8),
      },
      big: {
        fontSize: rem(19),
        lineHeight: rem(32),
        paddingLeft: rem(12),
        paddingRight: rem(12),
      },
    },
  },

  defaultVariants: {
    color: 'gray',
    size: 'small',
  },
});
